import {ClientInfo} from "./clientInfo.model";
import {DictType} from "./dictType.model";
import {PartItemArray} from "../partItemArray.model";

export class SvedUDSInfoType extends PartItemArray{
  clientInfo: ClientInfo = new ClientInfo();
  state: DictType = undefined;
  part: DictType = undefined;
}
